<template>
  <b-container class="order-add-ons">
    <add-ons-header></add-ons-header>
    <div class="order-add-ons__body">
      <!-- COVID-19 / CTH-1658 Add On Limits messaging -->
      <limited-addons-alert />

      <error-container v-bind:type="'general'"></error-container>
      <router-view />
    </div>
    <add-ons-footer></add-ons-footer>
  </b-container>
</template>

<script>
import OrderAddOnsHeader from "./OrderAddOnsHeader";
import OrderAddOnsFooter from "./OrderAddOnsFooter";
import LimitedAddonsAlert from './LimitedAddonsAlert';
import Errors from "./Errors";

export default {
  name: "OrderAddOns",
  components: {
    "add-ons-header": OrderAddOnsHeader,
    "add-ons-footer": OrderAddOnsFooter,
    "error-container": Errors,
    "limited-addons-alert": LimitedAddonsAlert
  },
  created() {
    this.$store.dispatch("orderAddOns/GET_ADD_ONS", this.$route.params.orderId);
  },
  mounted() {
    // hide the regular header
    document.getElementById("header").style.display = "none";
  },
  destroyed() {
    // show the regular header
    document.getElementById("header").style.display = null;
  }
};
</script>

<style lang="scss">
// This component is standalone, and therefore needs curbside styles
@import "../styles";
</style>

<style lang="scss" scoped>
@import "../assets/lib";

// Account for sticky header and footer
@media screen and (min-width: $breakpoint-desktop) {
  .order-add-ons__body {
    padding-top: 7rem;
  }
}
</style>
